import { keyframes } from '@emotion/react';

// Sequenced opacity pulse — each dot peaks 200ms after the previous one. The
// 75–100% dwell at .15 opacity creates the "rest" beat at the end of the
// cycle so the dots don't feel frantic.
export const dot1 = keyframes`
  0%, 75%, 100% { opacity: 0.15; }
  20%           { opacity: 1;    }
`;

export const dot2 = keyframes`
  0%, 75%, 100% { opacity: 0.15; }
  40%           { opacity: 1;    }
`;

export const dot3 = keyframes`
  0%, 75%, 100% { opacity: 0.15; }
  60%           { opacity: 1;    }
`;

export const spin = keyframes`
  from { transform: rotate(0deg);   }
  to   { transform: rotate(360deg); }
`;

export const fadeSlideIn = keyframes`
  from { opacity: 0; transform: translateY(5px); }
  to   { opacity: 1; transform: translateY(0);   }
`;
